
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.925 4.923c3.899-3.898 10.243-3.898 14.142 0L21.48 2.51l.833 7.5-7.5-.833 2.838-2.84c-3.12-3.12-8.194-3.117-11.313.001-3.12 3.12-3.12 8.195 0 11.314 3.119 3.118 8.195 3.12 11.314 0l1.414 1.414a9.97 9.97 0 01-7.071 2.924 9.971 9.971 0 01-7.071-2.924c-3.9-3.899-3.9-10.243 0-14.143z"}})])
          )
        }
      }
    